import { render, staticRenderFns } from "./ButtonCreatePage.vue?vue&type=template&id=faeccaf4&scoped=true&"
import script from "./ButtonCreatePage.vue?vue&type=script&lang=js&"
export * from "./ButtonCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCreatePage.vue?vue&type=style&index=0&id=faeccaf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faeccaf4",
  null
  
)

export default component.exports